import { IAppState } from 'spw-redux/reducer';

export const canDelete = (state: IAppState) =>
  state.projectSpaceTypeCategoriesReducer.canDeleteSubcategory;

export const associatedSpaceTypesAndWorksheets = (state: IAppState) => {
  return {
    associatedSpaceTypes:
      state.projectSpaceTypeCategoriesReducer.associatedSpaceTypes,
    associatedWorksheets:
      state.projectSpaceTypeCategoriesReducer.associatedWorksheets,
  };
};

export const selectAssociatedFloorplans = (state: IAppState) =>
  state.projectSpaceTypeCategoriesReducer.associatedFloorplans;
